import { ProductViewConfigurator } from '~/types/configurator';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'Clear'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-clear.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'clear',
                    description: (description = 'Transparent.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Color options:',
            hideOnProductPage: true,
        },
        {
            key: 'finish',
            keyLabel: 'finish',
            label: 'Finish',
            choices: [
                {
                    label: (label = 'Gloss'),
                    detailsModalLabel: label,
                    value: 'gloss',
                    description: (description = 'High gloss finish.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Finish options:',
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
